import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./caregiver.css";
import { ReactComponent as CloseIcon } from "../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../common/cardLayout/CardLayout";
import { notify } from "../../../util/helpers";
import {
  collectCaregiverAnswers,
  fetchPendingAssessmentsLogic,
  fetchRecentAssessmentsLogic,
  fetchScheduledAssessmentsLogic,
} from "../../../store/features/patient/assessmentsSlice";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "500px", // Limit the maximum width for larger screens
  },
};

const QuestionnaireTile = ({
  data,
  answers,
  selectedAnswers,
  setSelectedAnswer,
}) => {
  const handleAnswerSelection = (answerID, questionID) => {
    const temp = { ...selectedAnswers };
    temp[questionID] = answerID.toString() + "|" + questionID.toString();
    setSelectedAnswer(temp);
  };
  return (
    <div
      className="container-fluid"
      style={{
        border: "1px solid lightgray",
        margin: "1% 0px",
        borderRadius: "8px",
        padding: "1em",
      }}
    >
      <div className="d-flex justify-content-start question-tab">
        <div className="question-sno">Q{data?.sort}</div>
        <div className="question-main">
          <label style={{ fontSize: "100%" }}>{data?.text}</label>
        </div>
      </div>
      <div className="answers-tab">
        {answers &&
          answers?.length > 0 &&
          answers?.map((item) => {
            const uid = item?.id.toString() + "|" + data?.id.toString();
            return (
              <div className="answer" key={item?.id}>
                <input
                  type="radio"
                  id={uid}
                  checked={selectedAnswers[data?.id.toString()] === uid}
                  onChange={() => {
                    handleAnswerSelection(item?.id, data?.id);
                  }}
                />
                <span
                  onClick={() => {
                    document.getElementById(uid).click();
                  }}
                >
                  {item?.text}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const AssessmentModal = ({ modalIsOpen, setIsOpen, data,resetDropdown }) => {
  Modal.setAppElement("#root");
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.app);
  function closeModal() {
    if (loading) {
      notify("Please wait while we record your answers!", "info");
      return;
    }
    resetDropdown();
    setAnswers({});
    setIsOpen(false);
  }
  const handleSubmit = () => {
    if (loading) {
      notify("Please wait while we record your answers!", "info");
      return;
    }
    const collectedAnswers = Object.values(answers);
    if (collectedAnswers.length !== data?.questionnaire.length) {
      notify("Please answer all of the given questions!", "error");
      return;
    }
    const formattedData = collectedAnswers.map((item) => {
      const temp = item.split("|");
      return { question: parseInt(temp[1]), answer: parseInt(temp[0]) };
    });

    const payload = {
      assessment: data?.id,
      question_answer_list: formattedData,
    };

    setLoading(true);
    collectCaregiverAnswers(payload)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          if (user) {
            dispatch(fetchPendingAssessmentsLogic(user?.id));
            dispatch(fetchRecentAssessmentsLogic(user?.id));
            dispatch(fetchScheduledAssessmentsLogic(user?.id));
          }
          notify("Your answers were recorded successfully!");
          setAnswers({});
          closeModal();
        } else {
          notify("Something went wrong! Try again later!", "error");
        }
        resetDropdown();
      })
      .catch((e) => {
        setLoading(false);
        console.log("Error submitting patient's answers!", e);
        notify("Something went wrong! Try again later!", "error");
        resetDropdown();
      });
  };
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}    
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="container-fluid d-flex justify-content-between">
            <h3 className="text-center">{data?.name}</h3>
            <h3>
              {Object.entries(answers)?.length}/{data?.questionnaire?.length}
            </h3>
          </div>
          <div
            className="container-fluid"
            style={{ overflowX: "scroll", height: "70vh" }}
          >
            {data?.questionnaire.map((item) => {
              return (
                <QuestionnaireTile
                  data={item}
                  key={item?.sort}
                  answers={data?.answer_group?.answers}
                  selectedAnswers={answers}
                  setSelectedAnswer={setAnswers}
                />
              );
            })}
          </div>
          <div
            className="d-flex justify-content-end w-100 container-fluid"
            style={{ gap: "5%" }}
          >
            <button
              onClick={() => {
                closeModal();
              }}
              className="btn alternative-btn"
            >
              Cancel
            </button>
            <button
              className="primary-btn"
              onClick={() => {
                handleSubmit();
              }}
              disabled={loading}
            >
              Submit
            </button>
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default AssessmentModal;
